import React from "react"
import classnames from "classnames"
import styles from "./FeaturedCategoriesTab.less"
import { Tabs, HeroContent } from "AtomicContainers"
import componentParser from "AtomicUtils/componentParser"
import {
  InputSelect
} from "AtomicComponents"
import { WINDOW } from 'AtomicUtils/environment'
import debounce from 'AtomicUtils/debounce'

class FeaturedCategoriesTab extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: 0,
      tabType: WINDOW && WINDOW.innerWidth
    }
  }

  componentDidMount(){
    setTimeout(()=>{
      this._updateDimensions()
    },100)
    WINDOW.addEventListener("resize", debounce(this._updateDimensions, 250));
  }

  componentWillUnmount(){
    WINDOW.removeEventListener("resize", debounce(this._updateDimensions, 250));
  }

  _updateDimensions = () => {
    const {
      desktopTabOptions='scroll',
      mobileTabOptions='scroll'
    } = this.props

    if (WINDOW && WINDOW.innerWidth && WINDOW.innerWidth !== this.state.windowWidth) {
      if (!this.state.windowWidth || ((this.state.windowWidth >= 768 && WINDOW.innerWidth < 768) || (this.state.windowWidth < 768 && WINDOW.innerWidth >= 768))) {
        this.setState({
          windowWidth: WINDOW && WINDOW.innerWidth,
        }, () => {
          this.setState({
            tabType: this.state.windowWidth >= 768 ? desktopTabOptions : mobileTabOptions
          })
        })
      }
    }
  }

  _handleClick = (activeIndex) => {
    this.setState({
      activeIndex: activeIndex
    })
  }

  _handleChange = (value) => {
    const {
      components = [],
    } = this.props
    let changedIndex = components.findIndex(item => item.props.title === value)
    if (!changedIndex || changedIndex < 0) changedIndex = 0
    this.setState({
      activeIndex: changedIndex
    })
  }

  render() {
    const {
      components = [],
      gtm,
      heading,
      numberOfWrappedItems,
      description,
    } = this.props

    const { tabType, activeIndex } = this.state

    const tabNames = components.map(item => {
      return {
        name: item.props.title,
        label: item.props.title,
        value: item.props.title
      }
    })

    let activeComponents = components[activeIndex] && components[activeIndex].props.components

    // legacy
    if (activeComponents){
      if (activeComponents[0] &&
        (
          activeComponents[0].name === 'ImageToutBlock' ||
          activeComponents[0].name === 'FeatureYouTube' ||
          activeComponents[0].name === 'CardYoutubePlayer' ||
          activeComponents[0].name === 'ArticlePreview'
        )
      ) {
        activeComponents = [{
          name: 'CardYoutubePlayerList',
          props: {
            showCounting: false,
            scrolling: components[activeIndex].props.tabOptions === "stack" ? false : true,
            numberOfColumns: 4,
            components: activeComponents.map(item => {
              return {
                ...item,
                props: {
                  ...item.props,
                  gtm: gtm
                },
                videoSrc: item.props.youTubeId
              }
            })
          }
        }]
      }
    }

    return (
      <div
        className={classnames({
          [styles.FeaturedCategoriesTab]: true,
        })}>
        { (heading || description) &&
          <HeroContent
            heading={heading}
            description={description}
          />
        }
        {(
          tabType === 'scroll' ||
          tabType === 'stack'
        ) &&
          <Tabs
            onClick={this._handleClick}
            options={tabNames}
            numberOfWrappedItems={numberOfWrappedItems}
            animatedLine
            scrolling={tabType === 'scroll'}
          />
        }
        {
          tabType === 'dropdown' && tabNames && tabNames[0] &&
          <InputSelect
            onChange={this._handleChange}
            options={tabNames}
            required
            withoutStar
            defaultValue={tabNames[activeIndex]}
          />
        }
        <div>
          { activeComponents && tabType &&
            componentParser(activeComponents)
          }

          {!activeComponents &&
            <div></div>
          }
        </div>
      </div>
    )
  }
}

export default FeaturedCategoriesTab



// WEBPACK FOOTER //
// ./src/AtomicContainers/FeaturedCategoriesTab/FeaturedCategoriesTab.jsx